import { Reducer } from 'redux';
import {
  DELETE_ON_REQUEST_RULE, GET_ON_REQUEST_RULE, GET_ON_REQUEST_RULE_LIST, OnRequestRuleActionTypes, OnRequestRuleState, POST_ON_REQUEST_RULE, PUT_ON_REQUEST_RULE, UPDATE_ON_REQUEST_RULE_FILTERS
} from '../types/onrequestrule.types';

const initialState: OnRequestRuleState = {
  onRequestRules: [],
  selectedOnRequestRule: null,
  postSuccess: null,
  lastFetch: null,
  totalPages: 1,
  totalElements: 0,
  filters: null
};

export const onRequestRuleReducer: Reducer<OnRequestRuleState> = (
  state: OnRequestRuleState = initialState, action
) => {
  const timeOfAction = new Date().getTime();
  switch ((action as OnRequestRuleActionTypes).type) {
    case GET_ON_REQUEST_RULE_LIST:
      return {
        ...state,
        onRequestRules: action.payload.page.content,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalPages: action.payload.page.totalPages,
        totalElements: action.payload.page.totalElements
      };
    case GET_ON_REQUEST_RULE:
      return {
        ...state,
        postSuccess: null,
        selectedOnRequestRule: action.payload.selectedOnRequestRule,
        lastFetch: timeOfAction
      };
    case POST_ON_REQUEST_RULE:
      return {
        ...state,
        postSuccess: true,
        selectedOnRequestRule: action.payload.newOnRequestRule,
        lastFetch: timeOfAction
      };
    case PUT_ON_REQUEST_RULE:
      return {
        ...state,
        selectedOnRequestRule: action.payload.selectedOnRequestRule,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_ON_REQUEST_RULE:
      return {
        ...state,
        selectedOnRequestRule: null,
        lastFetch: timeOfAction
      };
    case UPDATE_ON_REQUEST_RULE_FILTERS:
      return {
        ...state,
        filters: action.payload.filters
      };
    default:
      return state;
  }
};
